// extracted by mini-css-extract-plugin
module.exports = {"title":"a10a3f92e9--title--V_xzC","subtitle":"a10a3f92e9--subtitle--KeTz8","rooms":"a10a3f92e9--rooms--CZ80N"};